<template>
  <div class="eligibility-documents">
    <v-list one-line v-if="documents[0]">
      <template v-for="(document, index) in documents">
        <v-subheader
        v-if="document.header"
        :key="document.header"
        >
        {{ document.header }}
      </v-subheader>

      <v-divider
      v-else-if="document.divider"
      :inset="document.inset"
      :key="index"
      ></v-divider>

      <v-list-tile v-else :key="document.title">
        <v-list-tile-avatar>
          <v-icon>{{ document.icon }}</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ document.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
  <v-subheader v-else>No documents available</v-subheader>
</div>
</template>

<script>
// Helpers
import _ from 'lodash'

export default {
  props: { eligibility: Object },

  created() {
    if (_.get(this.eligibility, 'profile.identityDocument')) {
      this.documents.push(
        { header: 'Identification Documents' },
        {
          icon: 'mdi-account-box',
          title: 'Identity Document Available'
        }
      )
    }

    if (_.get(this.eligibility, 'profile.profileQualifications')) {
      this.eligibility.profile.profileQualifications.forEach((q, i) => {
        const registration = _.get(q, 'proofOfRegistration')
        const transcript = _.get(q, 'transcript')

        if (registration || transcript) {
          this.documents.push({ header: `${q.qualificationTypeName} ${q.specialization}` })
        }

        if (registration) {
          this.documents.push({
            icon: 'mdi-file-account',
            title: 'Proof of Registration Available'
          })
        }

        if (transcript)
          this.documents.push({
            icon: 'mdi-file-document',
            title: 'Transcript Available'
          })
      })
    }
  },

  data() {
    return {
      documents: []
    }
  }
}
</script>
